// extracted by mini-css-extract-plugin
export default {"root":"ConnectPolicy_root__dd0O9","message":"ConnectPolicy_message__OU9FT","link":"ConnectPolicy_link__KdGBr"};